import React, { ReactNode } from 'react'
import CartContextProvider from 'src/lib/contexts/CartContext'

interface CartLayoutProps {
  children: ReactNode
  title: string
  previewComponent?: ReactNode
}

const CartLayout: React.FC<CartLayoutProps> = ({ children, title, previewComponent }) => {
  return (
    <CartContextProvider>
      <div className='flex flex-col space-y-4 p-8'>
        <div className='flex justify-between items-center w-full'>
          <span className='text-xl font-semibold text-carbon'>{title}</span>
        </div>
        <div className='flex w-full'>
          <div className='w-7/12'>{children}</div>
          {previewComponent && <div className='relative w-5/12'>{previewComponent}</div>}
        </div>
      </div>
    </CartContextProvider>
  )
}

export default CartLayout
